// src/platform/classification-tag/types.ts
var PlatformClassificationTagAriResourceOwner = "platform", PlatformClassificationTagAriResourceType = "classification-tag";

export {
  PlatformClassificationTagAriResourceOwner,
  PlatformClassificationTagAriResourceType
};
